import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=cbdd3e70&scoped=true"
import script from "./Automation.vue?vue&type=script&lang=js"
export * from "./Automation.vue?vue&type=script&lang=js"
import style0 from "./Automation.vue?vue&type=style&index=0&id=cbdd3e70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdd3e70",
  null
  
)

export default component.exports